import { createSelector } from "reselect";

import { itemSelectors } from "../../modules/items";
import { narrativeSelectors } from "../../modules/narrative";
import { syncSelectors } from "../../modules/sync";

/**
 * @param {TimelineRecord} state
 */
const getLocalNarrativeItemIds = createSelector(
  // inputs
  narrativeSelectors.getNarrativeTreeIds,
  itemSelectors.getAllItemIdsAllowedInNarrative,
  syncSelectors.getLocalToExternalIds,
  // output
  (treeIds, availableItemIds, localToExternalIds) => {
    const additionalIds = localToExternalIds
      .map((e, l) => l)
      .toList()
      .filter(id => availableItemIds.indexOf(id) >= 0);
    return treeIds
      .concat(additionalIds)
      .toSet()
      .toList();
  }
);

export default getLocalNarrativeItemIds;
